import photo1 from "/public/images/events/stages/stage-combat-13/photo1.webp";
import photo2 from "/public/images/events/stages/stage-combat-13/photo2.webp";
import photo3 from "/public/images/events/stages/stage-combat-13/photo3.webp";
import photo4 from "/public/images/events/stages/stage-combat-13/photo4.webp";

export const stageCombat13Images = [
  {
    src: photo1,
    alt: "Stage Combat 2013 - Photo 1",
    format: "3:2" as const,
  },
  {
    src: photo2,
    alt: "Stage Combat 2013 - Photo 2",
    format: "3:2" as const,
  },
  {
    src: photo3,
    alt: "Stage Combat 2013 - Photo 3",
    format: "3:2" as const,
  },
  {
    src: photo4,
    alt: "Stage Combat 2013 - Photo 4",
    format: "2:3" as const,
  },
];
